import React, { useState, useEffect, useCallback } from "react";
import {
  Button,
  Input,
  Select,
  Radio,
  Checkbox,
  Space,
  Card,
  Dropdown,
  Menu,
  Typography,
  Switch,
  InputNumber,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  ConfigProvider,
  DatePicker,
  Upload,
} from "antd";
import {
  DownOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  PlusSquareTwoTone,
  RightCircleOutlined,
  LeftCircleOutlined,
  MinusCircleOutlined,
  UploadOutlined,
  EllipsisOutlined,
  MoreOutlined,
  EditFilled,
  CopyOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import hamburgerIcon from "../../assets/images/hamburger.png";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const { Title, Text } = Typography;
const { Option } = Select;

const COMPONENT_TYPES = {
  SECTION: "Section",
  TEXT: "Text Input",
  NUMBER: "Number Input",
  RADIO: "Radio",
  DROPDOWN: "Dropdown",
  CHECKBOX: "Checkbox",
  HEADER: "Header",
  DATE: "Date Picker",
  FILE: "File Upload",
};

let idCounter = 0;
const generateId = () => {
  idCounter += 1;
  return `component_${idCounter}`;
};

const ComponentList = ({ onDragStart }) => {
  const components = Object.values(COMPONENT_TYPES);

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  return (
    <div>
      {components.map((type) => (
        <div
          key={type}
          draggable
          onDragStart={(e) => onDragStart(e, type)}
          style={{
            cursor: "move",
            padding: "10px",
            border: "1px solid #ccc",
            marginBottom: "5px",
            backgroundColor: "#f0f0f0",
          }}
        >
          {type}
        </div>
      ))}
    </div>
  );
};

const SectionComponent = ({
  component,
  onUpdate,
  onRemove,
  onAdd,
  onEdit,
  onDuplicate,
  children,
  showMenu = true,
}) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [isComplete, setisComplete] = useState(component.iscomplete || false);

  const handleCompleteToggle = (checked) => {
    setisComplete(checked);
    onUpdate(component.id, { ...component, iscomplete: checked });
  };
  const subMenuItems = [
    {
      key: "addHeader",
      // label: "Add Header",
      label: t("Add Header"),
      onClick: () => onAdd(component.id, "Header"),
    },
    {
      key: "addText",
      // label: "Add Text Input",
      label: t("Add test input "),
      onClick: () => onAdd(component.id, "Text Input"),
    },
    // {
    //   key: "addNumber",
    //   label: "Add Number Input",
    //   onClick: () => onAdd(component.id, "Number Input"),
    // },
    {
      key: "addRadio",
      // label: "Add Radio",
      label: t("Add Radio"),
      onClick: () => onAdd(component.id, "Radio"),
    },
    {
      key: "addDropdown",
      // label: "Add Dropdown",
      label: t("Add Dropdown"),
      onClick: () => onAdd(component.id, "Dropdown"),
    },
    {
      key: "addCheckbox",
      // label: "Add Checkbox",
      label: t("Add Checkbox "),
      onClick: () => onAdd(component.id, "Checkbox"),
    },
    {
      key: "addDate",
      // label: "Add Date Picker",
      label: t("Add Date Picker "),
      onClick: () => onAdd(component.id, "Date Picker"),
    },
    // {
    //   key: "addFile",
    //   label: "Add File Upload",
    //   onClick: () => onAdd(component.id, "File Upload"),
    // },
  ];
  const menuItems = [
    {
      key: "add",
      label: (
        <Dropdown menu={{ items: subMenuItems }} trigger={["hover"]}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <PlusOutlined />
            {/* Add Element */}
            {t("Add element ")}
          </div>
        </Dropdown>
      ),
      // onClick: () => add(component.id),
    },
    {
      key: "edit",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <EditFilled />
          {/* Edit */}
          {t("Edit ")}
        </div>
      ),
      onClick: () => onEdit(component.id),
    },
    {
      key: "duplicate",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <CopyOutlined />
          {/* Duplicate */}
          {t("Duplicate ")}
        </div>
      ),
      onClick: () => onDuplicate(component.id),
    },
    {
      key: "remove",
      label: (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <ClearOutlined />
          {/* Remove */}
          {t("Remove ")}
        </div>
      ),
      onClick: () => onRemove(component.id),
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            headerBg: "#ffffff",
            headerHeight: 40,
          },
          Switch: {
            colorPrimary: "#00246A",
          },
        },
      }}
    >
      <Card
        size="small"
        style={{
          marginBottom: 16,
          borderRadius: 15,
          border: "1px solid #8294B6",
          position: "relative",
          minHeight: "200px",
          width: "100%",
        }}
        bodyStyle={{ padding: "20px 10px" }}
      >
        <div
          style={{
            position: "absolute",
            top: "-12px",
            left: 5,
            padding: "0 30px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {showMenu && (
            <Dropdown
              menu={{
                items: component.iscomplete
                  ? menuItems.filter((item) => item.key !== "add")
                  : menuItems,
              }}
              trigger={["click"]}
            >
              <MoreOutlined
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
              />
            </Dropdown>
          )}
          <div style={{ backgroundColor: "white", fontWeight: 500 }}>
            {" "}
            {component.sectionname}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "-10px",
            right: "15%",
            backgroundColor: "white",
          }}
        >
          <Text
            style={{ fontSize: "12px", marginRight: "4px", color: "#00246a" }}
          >
            {/* complete? */}
            {t("Complete?")}
          </Text>
          <Switch
            disabled={!showMenu}
            size="small"
            checked={isComplete}
            onChange={handleCompleteToggle}
          />
        </div>
        {children}
      </Card>
    </ConfigProvider>
  );
};

const FormComponent = ({
  component,
  onUpdate,
  onRemove,
  bg,
  srno,
  showMenu = true,
  onCheck,
}) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-FormBuilder-Add-Edit").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [form] = Form.useForm();

  const showEditModal = () => {
    form.setFieldsValue(component);
    setIsEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setIsEditModalVisible(false);
  };

  const handleEditModalSave = () => {
    form.validateFields().then((values) => {
      console.log(values);
      onUpdate(component.id, { ...component, ...values });
      setIsEditModalVisible(false);
    });
  };

  const menuItems = [
    {
      key: "edit",
      // label: "Edit",
      label: t("Edit "),
      onClick: showEditModal,
    },
    {
      key: "remove",
      // label: "Remove",
      label: t("Remove "),
      onClick: () => onRemove(component.id),
    },
  ];

  const renderInput = () => {
    switch (component.type) {
      case "Header":
        return;
      case "Text Input":
        return (
          <Input
            style={{ width: "100%" }}
            onChange={(e) => onCheck && onCheck(component?.id, e)}
          />
        );

      case "Radio":
        return (
          <Radio.Group
            style={{
              display: "flex",
              flexDirection: component.options.length > 3 ? "column" : "row",
              alignItems:
                component.options.length > 3 ? "flex-start" : "center",
              justifyContent: "space-between",
            }}
            onChange={(e) => onCheck && onCheck(component?.id, e)}
          >
            {component.options?.map((option, index) => (
              <Radio key={index} value={option?.optionName}>
                {option?.optionName}
              </Radio>
            ))}
          </Radio.Group>
        );
      case "Dropdown":
        return (
          <Select
            style={{ width: "100%" }}
            onChange={(e) => onCheck && onCheck(component?.id, e)}
          >
            {component.options?.map((option, index) => (
              <Option key={index} value={option?.optionName}>
                {option?.optionName}
              </Option>
            ))}
          </Select>
        );
      case "Checkbox":
        return (
          <Checkbox.Group
            onChange={(e) => onCheck && onCheck(component?.id, e)}
            style={{
              display: "flex",
              flexDirection: component.options.length > 3 ? "column" : "row",
              alignItems:
                component.options.length > 3 ? "flex-start" : "center",
              justifyContent: "space-between",
            }}
          >
            {component.options?.map((option, index) => (
              <Checkbox key={index} value={option?.optionName}>
                {option?.optionName}
              </Checkbox>
            ))}
          </Checkbox.Group>
        );
      case "Date Picker":
        return (
          <DatePicker
            style={{ width: "100%" }}
            onChange={(e) => onCheck && onCheck(component?.id, e)}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div style={{ backgroundColor: bg }}>
      <div
        className="flex-wrap flex-md-nowrap"
        style={{
          width: "100%",
          // marginBottom: 8,
          display: "flex",
          flexDirection:
            component.options.length > 3 || component.title.length > 90
              ? "column"
              : "row",
          justifyContent: "space-between",
          padding: 1,
          // height: 35,
          minHeight: 35,
          alignItems:
            component.options.length > 3 || component.title.length > 90
              ? "flex-start"
              : "center",
          paddingBootom: component.title.length > 90 && "1rem",
        }}
      >
        <span
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            marginBottom: component.title.length > 90 && "1rem",
          }}
        >
          <span style={{ marginRight: "5px" }}>{`${srno}.`}</span>
          {component.title.length < 90 ? (
            <input
              value={component.title}
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: component.type === "Header" && 16,
                fontWeight: component.type === "Header" && 500,
                // maxWidth: "55vw",
                width: "100%",
                wordBreak: "break-word",
                whiteSpace: "normal",
                height: "auto",
              }}
              onChange={(e) =>
                showMenu &&
                onUpdate(component.id, { ...component, title: e.target.value })
              }
            />
          ) : (
            <textarea
              value={component.title}
              // rows={1}
              style={{
                border: "none",
                backgroundColor: "transparent",
                fontSize: component.type === "Header" && 16,
                fontWeight: component.type === "Header" && 500,
                width: "100%",
                wordBreak: "break-word",
                // whiteSpace: "normal",
                height: "auto",

                // overflow: "hidden",
                resize: "none",
                padding: "8px",
                borderRadius: "4px",
                boxSizing: "border-box",
                fontSize: "16px",
              }}
              onChange={(e) =>
                showMenu &&
                onUpdate(component.id, { ...component, title: e.target.value })
              }
            />
          )}
        </span>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems:
              component.options.length > 3 || component.title.length > 90
                ? "flex-start"
                : "center",
            width: "100%",
            justifyContent:
              component.options.length > 3 || component.title.length > 90
                ? "space-between"
                : "flex-end",
          }}
        >
          <div style={{ minWidth: "14rem", marginRight: 10 }}>
            {" "}
            {renderInput()}
          </div>
          {component.type !== "Header" && showMenu && (
            <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
              <MoreOutlined style={{ cursor: "pointer" }} />
            </Dropdown>
          )}
        </div>
      </div>
      <Modal
        title="Edit Component"
        open={isEditModalVisible}
        onOk={handleEditModalSave}
        onCancel={handleEditModalCancel}
      >
        <Form form={form} layout="vertical">
          {(component.type === "Radio" ||
            component.type === "Dropdown" ||
            component.type === "Checkbox") && (
            <Form.List name="options">
              {(fields, { add, remove }) => (
                <>
                  {fields.map((field, index) => (
                    <Form.Item required={false} key={field.key}>
                      <Form.Item
                        {...field}
                        validateTrigger={["onChange", "onBlur"]}
                        noStyle
                        name={[field.name, "optionName"]}
                        rules={[
                          {
                            required: true,
                            whitespace: true,
                            message:
                              "Please input option's text or delete this field.",
                          },
                        ]}
                      >
                        <Input style={{ width: "60%" }} placeholder="Option" />
                      </Form.Item>
                      {fields.length > 1 && (
                        <MinusCircleOutlined
                          onClick={() => remove(field.name)}
                          style={{ marginLeft: 20 }}
                        />
                      )}
                    </Form.Item>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add({ optionName: "" })}
                      block
                    >
                      {/* Add Option */}
                      {t("Add Option")}
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          )}
        </Form>
      </Modal>
    </div>
  );
};

const RecursiveFormPreview = ({
  components,
  onUpdate,
  onRemove,
  onDrop,
  onAdd,
  onEdit,
  onDuplicate,
  srno,
  showMenu,
}) => {
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    const componentType = e.dataTransfer.getData("componentType");
    onDrop(componentType, id);
  };

  return (
    <div
      onDragOver={handleDragOver}
      onDrop={(e) => handleDrop(e, null)}
      style={{
        minHeight: "50px",
        border: "1px dashed #ccc",
        padding: "10px",
        marginBottom: "10px",
        backgroundColor: "#f9f9f9",
      }}
    >
      {components.map((component) => (
        <div key={component.id}>
          {component.type === COMPONENT_TYPES.SECTION ? (
            <SectionComponent
              component={component}
              onUpdate={(updatedComponent) =>
                onUpdate(component.id, updatedComponent)
              }
              onRemove={() => onRemove(component.id)}
              onAdd={onAdd}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, component.id)}
              childLength={component.children.length}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              showMenu={showMenu}
            >
              <RecursiveFormPreview
                components={component.children || []}
                onUpdate={onUpdate}
                onRemove={onRemove}
                onDrop={onDrop}
                onAdd={onAdd}
              />
            </SectionComponent>
          ) : (
            <FormComponent
              component={component}
              onUpdate={(updatedComponent) =>
                onUpdate(component.id, updatedComponent)
              }
              onRemove={() => onRemove(component.id)}
              srno={srno}
            />
          )}
        </div>
      ))}
    </div>
  );
};

const AddComponentButton = ({ onAdd, style, children }) => {
  const menu = (
    <Menu onClick={({ key }) => onAdd(key)}>
      {Object.entries(COMPONENT_TYPES).map(([key, value]) => (
        <Menu.Item key={value}>{value}</Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <PlusOutlined />
    </Dropdown>
  );
};

const CustomDndFormBuilder = ({
  formComponents,
  setFormComponents,
  onEdit,
  onDuplicate,
  handleAdd,
  handleAddSection,
  showMenu,
  onCheck,
}) => {
  // const createNewComponent = (componentType, parentId = null) => ({
  //   id: generateId(),
  //   type: componentType,
  //   title: `New ${componentType}`,
  //   parentId,
  //   iscomplete: false,
  //   children: componentType === COMPONENT_TYPES.SECTION ? [] : undefined,
  //   options: ["Option 1", "Option 2"],
  //   label: "Checkbox Label",
  // });

  const handleUpdate = (id, updatedComponent) => {
    setFormComponents((prevComponents) =>
      prevComponents.map((component) => {
        if (component.id === id) {
          return { ...component, ...updatedComponent };
        }
        if (component.children) {
          return {
            ...component,
            children: component.children.map((child) =>
              child.id === id ? { ...child, ...updatedComponent } : child
            ),
          };
        }
        return component;
      })
    );
  };

  const handleRemove = (id) => {
    setFormComponents((prevComponents) =>
      prevComponents.filter((component) => {
        if (component.id === id) return false;
        if (component.children) {
          component.children = component.children.filter(
            (child) => child.id !== id
          );
        }
        return true;
      })
    );
  };

  return (
    <div
      style={{
        // padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "10px",
        width: "100%",
      }}
    >
      {formComponents.map((component) => (
        <SectionComponent
          key={component.id}
          component={component}
          onUpdate={handleUpdate}
          onRemove={handleRemove}
          onAdd={handleAdd}
          onEdit={onEdit}
          onDuplicate={onDuplicate}
          showMenu={showMenu}
        >
          {component.children &&
            component.children.map((childComponent, index) => (
              <FormComponent
                key={childComponent.id}
                component={childComponent}
                onUpdate={handleUpdate}
                onRemove={handleRemove}
                bg={index % 2 ? "#ffffff" : "#fafafa"}
                srno={index + 1}
                showMenu={showMenu}
                onCheck={onCheck && onCheck.bind(null, component.id)}
              />
            ))}
        </SectionComponent>
      ))}
    </div>
  );
};

export default CustomDndFormBuilder;
